/**
 * TriageLegend — a collapsible explainer for the triage colour codes.
 *
 * The overview and detail screens speak the triage system's own colour
 * language; this legend reproduces the official ASDAA triage reference (the
 * sheet printed at the pronto soccorso): each colour, its urgency-level name,
 * and the official description of what it means. Rendered as a `<details>` so it
 * stays out of the way until tapped. Colour is never the only channel — every
 * row pairs the swatch with the level's name and a description (WCAG 2.1 AA, see
 * DECISIONS.md).
 */

import { TRIAGE_LEVELS } from "@/lib/triage";

export function TriageLegend() {
  return (
    <details className="triage-legend">
      <summary className="triage-legend__summary">Cosa significano i colori del triage?</summary>
      <p className="triage-legend__intro">
        Al pronto soccorso ogni paziente riceve un codice colore in base alla gravità: i più urgenti
        vengono visitati per primi, a prescindere dall'ordine di arrivo.
      </p>
      <dl className="triage-legend__list">
        {TRIAGE_LEVELS.map((t) => (
          <div key={t.code} className="triage-legend__row">
            <dt className="triage-legend__term">
              <span
                className="triage-legend__swatch"
                style={{ backgroundColor: t.colorVar }}
                aria-hidden="true"
              />
              <span className="triage-legend__label">{t.labelIt}</span>
              <span className="triage-legend__level">{t.levelNameIt}</span>
            </dt>
            <dd className="triage-legend__desc">{t.descriptionIt}</dd>
          </div>
        ))}
      </dl>
      <p className="triage-legend__source">
        Definizioni dei codici di triage dell'Azienda Sanitaria dell'Alto Adige (ASDAA).
      </p>
    </details>
  );
}
